// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S9OuG","top":"styles_top__3uXJQ","left":"styles_left__2FuvN","description":"styles_description__33Y0o"};